import * as React from "react";
import get from "lodash/get";

import "./DeliveredRewards.css";
import { ComponentBase, ComponentBaseProps } from "../ComponentBase";
import { StoreState } from "../../reducers";

export interface DeliveredRewardsProps extends ComponentBaseProps {
  onClick: () => void;
  action: string;
  successScreen: string;
  mode: string;
  content: string;
  rewardStats: StoreState["reward"]["rewardStats"];
}

export class DeliveredRewards extends ComponentBase<DeliveredRewardsProps> {
  // tslint:disable:cyclomatic-complexity
  render() {
    const {
      style,
      classNames,
      rewardStats,
      action,
      successScreen,
      mode,
      isEditing,
    } = this.props;
    const totalRewards = get(rewardStats, "totalCredits");
    const pendingRewards = get(rewardStats, "pendingCredits");
    const deliveredRewards = Number(totalRewards) - Number(pendingRewards);

    return (
      <div
        onDragStart={this.onDragStart}
        id={this.props.configName}
        onAnimationEnd={this.resetAnimation}
        style={{
          ...style,
          cursor: action || successScreen ? "pointer" : "inherit",
        }}
        className={`DeliveredRewards-text  DeliveredRewards-mode-${
          mode || "default"
        } ${classNames || ""} ${
          !isEditing ? "DeliveredRewards-text-preview" : ""
        } ${this.state.animationClass}`}
        aria-label={get(this.props, "label", "")}
        tabIndex={action ? 0 : undefined}
        ref={(component) => (this.component = component)}
      >
        {deliveredRewards}
      </div>
    );
  }
}
